import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useStore } from 'vuex';
	import { IStoreState, IVehicle } from '@/types.d';
	import { ECtas } from '@/enums';

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	// import { computed } from 'vue';
	const store = useStore<IStoreState>();
	const vehicle: IVehicle = (window as any).uvDetailPageVehicle;

	const handleClick = async ($event: Event) => {
		$event.preventDefault();
		store.commit('setEnquiryModal', {
			isVisible: true, 
			type: ECtas.certifiedText, 
			vehicle: vehicle
		});
	}
	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    onClick: handleClick
  }, "Toyota Certified"))
}
}

})